module.exports = __webpack_public_path__ + "static/img/delete.e056fbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/query/delete.svg
// module id = dsBx
// module chunks = 46